import m from "../../geodata/es2015/qatarHigh";
window.am4geodata_qatarHigh = m;


//////////////////
// WEBPACK FOOTER
// ./geodata/qatarHigh.js
// module id = null
// module chunks = 